import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CopyService {
  constructor() {}

  copying(str, type) {
    const data = new ClipboardItem({
      'text/plain': new Blob([str], { type: 'text/plain' }),
      'text/html': new Blob([str], { type: 'text/html' }),
    });
    navigator.clipboard.write([data]);
    return true;
  }
}
